export default __webpack_public_path__ + "cdf9ee1578d8cdb2eedd8400923c6ff0.jpg";